import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=3b3fe884&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=js"
export * from "./ClientForm.vue?vue&type=script&lang=js"
import style0 from "./ClientForm.vue?vue&type=style&index=0&id=3b3fe884&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3fe884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3fe884')) {
      api.createRecord('3b3fe884', component.options)
    } else {
      api.reload('3b3fe884', component.options)
    }
    module.hot.accept("./ClientForm.vue?vue&type=template&id=3b3fe884&scoped=true", function () {
      api.rerender('3b3fe884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/components/ClientForm.vue"
export default component.exports